module.exports = __webpack_public_path__ + "img/zhuanpan-1.371337ca.png";